import AxiosRequestBuilder from '@/utils/axios-request-builder'
import { Endpoints, urlBuilder } from '@/connectors/endpoints'
import { mapper } from '@/mappers'
import reverseObjUtil from '@/utils/reverse-obj.util'
import { IAccruals } from '@/types/accruals'
import { createAccrualMap } from '@/mappers/accruals'

const updateAccrual = (accrualId: number, formData: IAccruals) => {
  return new AxiosRequestBuilder<IAccruals>({
    url: urlBuilder(Endpoints.UPDATE_ACCRUALS, String(accrualId)),
    method: 'patch',
    data: formData,
    requestMapperFunction: mapper,
    requestMapper: reverseObjUtil(createAccrualMap)
  }).exec()
}

export default updateAccrual
